import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/auth/auth.service';
import { LayoutService } from '../../../core/layout/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from '../../constants/constants';
import { ProfileModalComponent } from '../profile-modal/profile-modal.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, MenuModule, ButtonModule, RouterLink, ProfileModalComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent {
  profileItems: MenuItem[] = [];
  showProfileModal = false;
  private readonly destroyRef = inject(DestroyRef);
  private readonly layoutService = inject(LayoutService);

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.buildProfileItems();
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.buildProfileItems());
  }

  private buildProfileItems(): void {
    this.profileItems = [
      {
        label: this.translate.instant(CONSTANTS.NAVBAR_PROFILE_SETTINGS),
        icon: 'pi pi-cog',
        command: () => this.openProfileModal(),
      },
      {
        label: this.translate.instant(CONSTANTS.NAVBAR_LOGOUT),
        icon: 'pi pi-sign-out',
        command: () => this.logout(),
      },
    ];
  }

  toggleSidebar(): void {
    this.layoutService.toggleSidebar();
  }

  openProfileModal(): void {
    this.showProfileModal = true;
  }

  logout(): void {
    this.authService.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant(CONSTANTS.TOAST_LOGOUT_SUCCESS_SUMMARY),
          detail: this.translate.instant(CONSTANTS.TOAST_LOGOUT_SUCCESS_DETAIL),
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant(CONSTANTS.TOAST_LOGOUT_FAILED_SUMMARY),
          detail: this.translate.instant(CONSTANTS.TOAST_LOGOUT_FAILED_DETAIL),
        });
      },
    });
  }
}
